import React from 'react'

export default function BtnTickIcon() {
    return (
        <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.85998 1.87457L4.57908 7.15546C4.38105 7.3535 4.13021 7.44591 3.87936 7.44591C3.62852 7.44591 3.37768 7.3535 3.17964 7.15546L1.19926 5.17513C0.816393 4.79227 0.816393 4.15856 1.19926 3.77569C1.58212 3.39283 2.21583 3.39283 2.59869 3.77569L3.87936 5.05631L8.46054 0.475137C8.8434 0.0922721 9.47711 0.0922721 9.85998 0.475137C10.2428 0.858001 10.2428 1.49171 9.85998 1.87457Z" fill="white" />
        </svg>

    )
}
